import { Controller } from "@hotwired/stimulus"

// Schließen-Button einer Flash-Meldung (Ui::FlashComponent)
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}
